import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { api } from "../../core"
import { AddPushDeviceRequest, MobileOS } from "popopo-msg"
import { config } from "~/config"

type UserDeviceRegisterForms = AddPushDeviceRequest & {
  name: string,
  system: MobileOS.IOS | MobileOS.ANDROID
}

export const UserDeviceRegisterForm = (props: { firebase: User }) => {
  const form = useForm<UserDeviceRegisterForms>({
    mode: "onBlur",
    defaultValues: {
      name: `MyDevice${Date.now()}`,
      app: `com.popopo.popopo${config.env === "prod" ? "": `.${config.env}` }`,
      voipToken: "0123456789",
      system: MobileOS.IOS,
    },
  })
  const { isSubmitting } = form.formState

  const onSubmit = async (value: UserDeviceRegisterForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const deviceId = `${value.name}-${Date.now()}`
      await api.PUT("/api/v2/push/devices/{deviceId}", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        params: { path: { deviceId } },
        body: { ...value, deviceName: value.name }
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <div className="form-floating">
          <input className="form-control" {...form.register("name")} disabled={isSubmitting}/>
          <label>Name</label>
        </div>

        <div className="form-floating">
          <input className="form-control" {...form.register("app")} disabled={isSubmitting}/>
          <label>App</label>
        </div>

        <div className="form-floating">
          <input className="form-control" {...form.register("voipToken")} disabled={isSubmitting}/>
          <label>VoIP Token</label>
        </div>

        <div className="form-floating">
          <select className="form-select" {...form.register("system")} disabled={isSubmitting}>
            <option value={MobileOS.IOS}>iOS</option>
            <option value={MobileOS.ANDROID}>Android</option>
          </select>
          <label>System</label>
        </div>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onSubmit)}>
          Register device
        </button>
      </form>
    </>
  )
}
